import { render } from "./proxy.vue?vue&type=template&id=4b071413"
import script from "./proxy.vue?vue&type=script&lang=js"
export * from "./proxy.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__